import {EntityData, field, SearchModel} from "@fedelta-pos/data-client";
import {Injectable, Injector} from "@angular/core";
import {IdentityModel} from "./identity.model";

export class IdentitySearchData extends EntityData<IdentitySearchData> {
    @field email: string;
    @field mobilePhone: string;
    @field passwordSet: boolean;
    @field appId: number;
    @field appName: string;
    @field lastUsage: Date;
}

@Injectable()
export class IdentitySearchModel extends SearchModel<IdentitySearchData> {
    constructor(injector: Injector) {
        console.log("--- IdentitySearchModel");

        super(injector);
    }

    retrieveByIdentity(identity: string, timeout?: number): Promise<IdentitySearchData> {
        const identityModel: IdentityModel = this.injector.get(IdentityModel);
        this.filter = {
            "loginType": identityModel.loginIdentificationMethod,
            "identity": identity
        };
        return super.retrieve(timeout);
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/identity-search.model.ts